export function SectionHeading({ number, title, light = false, align = "left" }) {
  return (
    <div className={`mb-4 ${align === "center" ? "text-center" : ""}`} data-testid={`section-heading-${number}`}>
      <div className={`inline-flex items-center gap-3 ${align === "center" ? "mx-auto" : ""}`}>
        <span className="font-mono text-sm font-bold tracking-widest text-piks-red">{number}</span>
        <span className={`h-px w-8 bg-gradient-to-r from-piks-goldline to-transparent`} />
        <span className={`font-mono text-xs font-semibold tracking-[0.25em] uppercase ${light ? "text-white/60" : "text-piks-muted"}`}>
          {title}
        </span>
      </div>
    </div>
  );
}
